interface Props {
  children?: React.ReactNode;
}

export const DetailTableHeaderRight: React.FC<Props> = ({ children }) => {
  return (
    <th
      scope="col"
      className="relative py-3.5 pl-3 pr-6 lg:text-sm md:text-sm text-xs font-semibold text-gray-900 text-right"
    >
      {children}
    </th>
  );
};
